/**
 * Store Redux Toolkit principal pour Flooz Collector
 */

import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

// Import des slices
import userSlice from './slices/userSlice';
import kidSlice from './slices/kidSlice';
import questionSlice from './slices/questionSlice';
import answerSlice from './slices/answerSlice';
import profilTypeSlice from './slices/profilTypeSlice';
import avatarSlice from './slices/avatarSlice';
import ageSectionSlice from './slices/ageSectionSlice';
import profilingSlice from './slices/profilingSlice';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import videoSlice from './slices/videoSlice';
import productsSlice from './productsSlice';
import cartSlice from './cartSlice';
import popupSlice from './slices/popupSlice';
import neuroSlice from './slices/neuroSlice';

// Auth : ne pas persister l'état transitoire OTP (bloquait « autre email » après rehydrate)
const authPersistConfig = {
  key: 'auth',
  storage,
  // Ne pas persister l'état de session : tokens = localStorage, init = AuthBootstrap
  blacklist: ['loading', 'error', 'otpSent', 'authInitialized', 'isAuthenticated', 'tokens'],
};

const persistedAuthReducer = persistReducer(authPersistConfig, authSlice);

// Configuration de persistance
const persistConfig = {
  key: 'baoubab-root',
  storage,
  whitelist: ['user', 'ui', 'cart'],
  blacklist: ['kid', 'question', 'answer', 'profilType', 'avatar', 'ageSection', 'profiling', 'videos', 'products', 'neuro'],
};

// Combinaison des reducers
const rootReducer = combineReducers({
  user: userSlice,
  kid: kidSlice,
  question: questionSlice,
  answer: answerSlice,
  profilType: profilTypeSlice,
  avatar: avatarSlice,
  ageSection: ageSectionSlice,
  profiling: profilingSlice,
  auth: persistedAuthReducer,
  ui: uiSlice,
  videos: videoSlice,
  products: productsSlice,
  cart: cartSlice,
  popup: popupSlice,
  neuro: neuroSlice,
});

// Reducer persisté
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.NODE_ENV !== 'production'
});

// Persistor pour redux-persist
export const persistor = persistStore(store);

// Types pour TypeScript (optionnel - à utiliser si conversion en .ts)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;